import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconPlanetOff = createReactComponent('outline', 'planet-off', 'PlanetOff', __iconNode);

export default IconPlanetOff;